import { makeStyles } from '@material-ui/core';

import palette from '../../../theme/palette';
import { EmaCurationsPalette } from './EmaCurationsStatusToggle.types';

const curationPalette = palette as EmaCurationsPalette;

export default makeStyles(theme => ({
  container: {
    textAlign: 'center'
  },
  label: {
    padding: theme.spacing(2),
    fontSize: theme.spacing(2),
    color: curationPalette.review.label,
    fontWeight: 'bold'
  },
  root: {
    background: '#dbd4fa5c',
    margin: '0 1rem',
    '& .Mui-selected': {
      background: `${curationPalette.buttons.purple} !important`,
      color: `${curationPalette.white} !important`,
      '&:hover': {
        opacity: 0.8,
        background: `${curationPalette.buttons.purple} !important`
      }
    }
  },
  infoIcon: {
    marginBottom: '-5px',
    marginLeft: '5px'
  }
}));
